import Image from "next/image"

import { Box } from "components/shared/box"

import styles from "./bot-with-rectangle.module.scss"

type BotWithRectangleProps = {
  imgSrc: string
  hoveredImgSrc: string
  showGradient?: boolean
  reversed?: boolean
}

export function BotWithRectangle({ imgSrc, hoveredImgSrc, showGradient, reversed }: BotWithRectangleProps) {
  const rectangleClassNames =
    "transition-opacity absolute top-0 bottom-0 left-[30%] w-[35%] sm:w-[min(45%,300px)] sm:left-[18%] rounded-2xl"
  const botClassNames =
    "w-[50%] h-0 pb-[50%] sm:w-[min(450px,70%)] sm:h-0 sm:pb-[min(450px,70%)] absolute bottom-0 left-[20%] sm:left-[5%] pointer-events-none"

  return (
    <Box className="flex-1 h-0 relative group pb-[min(600px,50%)] -mx-[5%]">
      <Box className={`${styles["rectangle"]} ${rectangleClassNames}`} />
      <Box
        className={`${styles["rectangle__hovered"]} ${
          showGradient ? "opacity-100" : "opacity-0"
        } group-hover:opacity-100 ${rectangleClassNames}`}
      />
      <Box className={`${botClassNames} ${reversed ? "-scale-x-100" : ""}`}>
        <Image src={showGradient ? hoveredImgSrc : imgSrc} layout="fill" alt="bot" />
      </Box>
      <Box
        className={`${botClassNames} opacity-0 group-hover:opacity-100 transition-opacity z-2 ${
          reversed ? "-scale-x-100" : ""
        }`}
      >
        <Image src={hoveredImgSrc} layout="fill" alt="bot" />
      </Box>
    </Box>
  )
}
